export const TAX_SLAB_ARRAY = [0, 5, 12, 18, 28]